import { Box, BoxProps } from '@mui/material';

interface SportsFallbackIconProps extends BoxProps {
  size?: number | string;
}

/**
 * A theme-aware trophy icon used as a fallback for sports items.
 * Renders as an inline SVG to correctly inherit currentColor from the parent.
 */
export function SportsFallbackIcon({ size = 20, sx, ...props }: SportsFallbackIconProps) {
  return (
    <Box
      component="svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        color: 'inherit',
        display: 'block',
        ...sx,
      }}
      {...props}
    >
      {/* Trophy Cup Body */}
      <path
        d="M6 4H18V10C18 13.3137 15.3137 16 12 16C8.68629 16 6 13.3137 6 10V4Z"
        fill="currentColor"
        fillOpacity="0.1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Left Handle */}
      <path
        d="M6 6H4C3.44772 6 3 6.44772 3 7V9C3 9.55228 3.44772 10 4 10H6"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Right Handle */}
      <path
        d="M18 6H20C20.5523 6 21 6.44772 21 7V9C21 9.55228 20.5523 10 20 10H18"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Base Stem */}
      <path
        d="M12 16V19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Pedestal */}
      <path
        d="M8 19H16V20C16 20.5523 15.5523 21 15 21H9C8.44772 21 8 20.5523 8 20V19Z"
        fill="currentColor"
        fillOpacity="0.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Detail highlight */}
      <path
        d="M12 6V11"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeOpacity="0.3"
        strokeLinecap="round"
      />
    </Box>
  );
}
